import React from 'react';

const ShootingStars = () => {
  return (
    <div className="fixed inset-0 w-full h-full pointer-events-none z-0 overflow-hidden">
      <div className="relative w-full h-full transform rotate-[135deg]">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="shooting-star"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              // Ultra-minimal: very long delays (up to 25s)
              animationDelay: `${Math.random() * 25000}ms`,
              animationDuration: `${Math.random() * 2000 + 3000}ms`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ShootingStars;
